import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// SVG Imports
import { resetLoginError } from "../../../redux/features/login/login";

// UTLIS Imports
import PasswordInputField from "../../_utils/CommonInputFields/PasswordInputField";
import PrimaryLargeButton from "../../_utils/CommonButtons/PrimaryLargeButton";
import ICONS from "../../../assets/Icons";

const EnterBackupCodes = ({
  cred,
  setCred,
  isFocus,
  setIsFocus,
  isLoading,
  isError,
  handleLogin,
  setIsBackupCodes,
}) => {
  // useDispatch
  const dispatch = useDispatch();

  // useNavigate
  const navigate = useNavigate();

  const handleTotpChange = (e) => {
    let value = e.target.value;
    if (value?.length <= 7) {
      if (isError === true) {
        dispatch(resetLoginError());
      }
      setCred({ ...cred, totp: value });
    }
  };

  return (
    <>
      <div className="w-full h-full grid place-items-center  Qlg:p-padding-base p-padding-sm">
        <div className="w-full Qsmd:w-fit rounded-border-radius-md p-[var(--border)] bg-[linear-gradient(154.44deg,rgba(97,117,153,0.5)_16.18%,rgba(100,100,100,0.5)_100.4%)] shadow-[0px_4px_4px_0px_#00000033]">
          <div className="Qsmd:p-padding-xl px-padding-sm py-padding-lg rounded-border-radius-md bg-primary-bg Qsmd:w-[var(--login-card-height)] w-full  h-fit">
            <div className="flex flex-col gap-gap-xl items-center">
              <div className="w-xpentra-logo-width-login h-[var(--gap-lg)]">
                <img
                  src={ICONS?.XPENTRA_WHITE}
                  alt=""
                />
              </div>
              <div
                className={`backupcodeswarning p-padding-md rounded-border-radius-md bg-emphasis w-full h-auto gap-gap-sm ${
                  isError ? " flex" : " hidden"
                }`}
              >
                <img
                  src={ICONS?.ERROR_WHITE_CIRCLE}
                  alt="Warning"
                />
                <p className="font-normal font-sans text-text-primary text-font-xs  w-full ">
                  Login using backup code, disables TOTP. Re-setup will be
                  required.
                </p>
              </div>
              <div className="flex flex-col  items-start justify-between w-full ">
                <h4 className="text-font-sm font-semibold font-sans text-text-primary mb-margin-xs ">
                  Enter backup code
                </h4>
                <p className=" text-font-xs font-normal font-sans text-text-primary mb-margin-md ">
                  Use one of the 10 backup codes provided during TOTP setup.
                </p>

                <PasswordInputField
                  bgColor="var(--primary-bg)"
                  fgColor="var(--text-secondary)"
                  isFullWidth={true}
                  placeholder="Enter code"
                  variant={
                    isError === true && !isLoading
                      ? "error"
                      : isFocus
                        ? "typing"
                        : "default"
                  }
                  fontKind="big"
                  value={cred?.totp}
                  spellCheck={false}
                  onInput={(e) => {
                    handleTotpChange(e);
                  }}
                />
                <h4
                  className="text-failed font-normal font-sans text-font-sm mt-margin-xs"
                  style={{ display: isError ? "flex" : "none" }}
                >
                  Invalid code.
                </h4>
                <p
                  className="entertotpcodes-right-backup-code hover:underline text-font-xs font-normal font-sans text-pending mt-margin-md"
                  onClick={() => {
                    setIsBackupCodes(false);
                    dispatch(resetLoginError());
                    setCred({ ...cred, totp: "", type: "totp" });
                    setIsFocus(false);
                  }}
                >
                  Use TOTP code
                </p>
                <p
                  className="entertotpcodes-right-backup-code hover:underline text-font-xs mt-margin-sm font-normal font-sans text-pending"
                  onClick={() => {
                    dispatch(resetLoginError());
                    navigate("/contactAdmin", {
                      state: {
                        totp: true,
                      },
                    });
                  }}
                >
                  Can't access TOTP/Backup code?
                </p>
              </div>
              <div className="w-full flex flex-col gap-gap-md items-center">
                <div className="w-full flex justify-center">
                  <PrimaryLargeButton
                    btnType="button"
                    btnText="Login with backup code"
                    hoverOption="black"
                    enabledBgColor="var(--positive-act)"
                    enabledTextColor="var(--text-primary)"
                    disabledBgColor="var(--text-disabled)"
                    disabledTextColor="var(--text-primary)"
                    isDisabled={cred?.totp?.length !== 7 || isError}
                    handleFunction={(e) => {
                      if (cred?.totp?.length !== 7 || isError) {
                        return;
                      }

                      handleLogin(e);
                    }}
                    isLoaderNeeded={true}
                    isLoading={isLoading}
                    isFillNeeded={true}
                    inActiveVariantNeeded={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EnterBackupCodes;
